import React from 'react';
import styled from 'styled-components';

const tinyclownIcon = '/tinyclown.gif';

function Mystery() {
  return (
    <Div>
      <img src={tinyclownIcon} alt="???" />
      <p>???</p>
    </Div>
  );
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  img {
    width: 128px;
    height: 128px;
    image-rendering: pixelated;
  }
  p {
    margin-top: 12px;
    font-family: 'Comic Sans MS', 'Comic Sans', cursive;
    font-size: 24px;
    color: #d00;
    letter-spacing: 4px;
  }
`;

export default Mystery;
